const englishToMyanmarNumber = (englishNumber) => {
    const myanmarNumbers = {
      0: '၀',
      1: '၁',
      2: '၂',
      3: '၃',
      4: '၄',
      5: '၅',
      6: '၆',
      7: '၇',
      8: '၈',
      9: '၉',
    };
  
    return String(englishNumber)
      .split('')
      .map((digit) => myanmarNumbers[digit])
      .join('');
  };

  export {
    englishToMyanmarNumber
  };